import { dual } from '../../Function/dist/effect-Function.esm.js';
import { empty as empty$1, fromIterable as fromIterable$1, get as get$1, modify as modify$1, remove as remove$1, set as set$1, size as size$1 } from '../../HashMap/dist/effect-HashMap.esm.js';
import { toString, toJSON, NodeInspectSymbol } from '../../Inspectable/dist/effect-Inspectable.esm.js';
import { update, get as get$2, make as make$1 } from '../../MutableRef/dist/effect-MutableRef.esm.js';
import { isSome } from '../../Option/dist/effect-Option.esm.js';
import { pipeArguments } from '../../Pipeable/dist/effect-Pipeable.esm.js';

/**
 * @since 2.0.0
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/MutableHashMap");

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

const MutableHashMapProto = {
  [TypeId]: TypeId,
  [Symbol.iterator]() {
    return this.backingMap.current[Symbol.iterator]();
  },
  toString() {
    return toString(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableHashMap",
      values: Array.from(this).map(toJSON)
    };
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  pipe() {
    return pipeArguments(this, arguments);
  }
};
const fromHashMap = backingMap => {
  const map = Object.create(MutableHashMapProto);
  map.backingMap = make$1(backingMap);
  return map;
};

/**
 * @since 2.0.0
 * @category constructors
 */
const empty = () => fromHashMap(empty$1());

/**
 * @since 2.0.0
 * @category constructors
 */
const make = (...entries) => fromIterable(entries);

/**
 * @since 2.0.0
 * @category conversions
 */
const fromIterable = entries => fromHashMap(fromIterable$1(entries));

/**
 * @since 2.0.0
 * @category elements
 */
const get = /*#__PURE__*/dual(2, (self, key) => get$1(self.backingMap.current, key));

/**
 * @since 2.0.0
 * @category elements
 */
const has = /*#__PURE__*/dual(2, (self, key) => isSome(get(self, key)));

/**
 * Updates the value of the specified key within the `MutableHashMap` if it exists.
 *
 * @since 2.0.0
 */
const modify = /*#__PURE__*/dual(3, (self, key, f) => {
  update(self.backingMap, modify$1(key, f));
  return self;
});

/**
 * Set or remove the specified key in the `MutableHashMap` using the specified
 * update function.
 *
 * @since 2.0.0
 */
const modifyAt = /*#__PURE__*/dual(3, (self, key, f) => {
  const result = f(get(self, key));
  if (isSome(result)) {
    set(self, key, result.value);
  } else {
    remove(self, key);
  }
  return self;
});

/**
 * @since 2.0.0
 */
const remove = /*#__PURE__*/dual(2, (self, key) => {
  update(self.backingMap, remove$1(key));
  return self;
});

/**
 * @since 2.0.0
 */
const set = /*#__PURE__*/dual(3, (self, key, value) => {
  update(self.backingMap, set$1(key, value));
  return self;
});

/**
 * @since 2.0.0
 * @category elements
 */
const size = self => size$1(get$2(self.backingMap));

export { empty, fromIterable, get, has, make, modify, modifyAt, remove, set, size };
